<template>
  <div>
    <EditServiceAgreementDialog :externaltrigger="dialogtrigger" :machineId="machine && machine.Id"
      :agreement="Agreement" @Update="update">
    </EditServiceAgreementDialog>
    <HoverMenu width="250" :nudgeamount="-3" :delay="300" @activatorclick="dialogtrigger++">
      <template v-slot:menu-activator>
        <v-card :color="backgroundColor" flat dark>
          <v-row no-gutters align="center" class="flex-nowrap">
            <div v-if="hasNextDateProximity" class="pl-2 pr-1 nowrapheader">
              <v-icon size="13">mdi-calendar</v-icon>
              {{ hasNextDateProximity }}
            </div>
            <v-btn icon :color="foregroundColor" small>
              <v-icon :size="size ? size : (!isPcBool ? 20 : 20)" v-text="'mdi-file-clock'" />
            </v-btn>
          </v-row>
        </v-card>
      </template>
      <template v-slot:menu-content>
        <v-card v-if="machineIsDeactivated" class="pa-2 text-center">
          {{ customerIsDeactivated ? $t("servicesystem.common_objects.service_agreement.customerinactive") :
            $t("servicesystem.common_objects.service_agreement.machineincative") }}
        </v-card>
        <v-card v-else-if="!hasAgreement" class="pa-2 text-center">
          {{ $t('servicesystem.common_objects.service_agreement.none') }}
        </v-card>
        <v-card v-else-if="!!Agreement" class="pa-2">
          <h4> {{ $t('servicesystem.common_objects.service_agreement.service_agreement') }}</h4>
          <h5>
            {{ $t('servicesystem.common_objects.service_agreement.with_job_generation') }} <i>{{
              Agreement.MachineTypeId ?
                $t('servicesystem.common_objects.service_agreement.inherited_from', {
                  okey:
                    $t("servicesystem.common_objects.machine_type.machine_type")
                }) : '' }}</i>
          </h5>
          <v-divider class="my-1"></v-divider>
          <v-row no-gutters v-if="machine.ServiceAgreementNextDate">
            <v-col cols="0">
              {{ $t('servicesystem.common_objects.service_agreement.next_date') }}:
            </v-col>
            <v-col cols="auto" class="primary--text">
              {{ i18nFormatDate(machine.ServiceAgreementNextDate) }}
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="0">
              {{ $t('servicesystem.common_objects.service_agreement.start_date') }}:
            </v-col>
            <v-col cols="auto">
              {{ !Agreement.ServiceFromInstallationDate ? i18nFormatDate(Agreement.ReocurrencyStartDate) :
                $t('servicesystem.common_objects.service_agreement.from_install_date') }}
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="0">
              {{ $t('servicesystem.common_objects.service_agreement.end_date') }}:
            </v-col>
            <v-col cols="auto" :class="isExpired ? 'error--text' : ''">
              {{ i18nFormatDate(Agreement.ReocurrencyEndDate) }}
            </v-col>
          </v-row>
          <v-divider class="my-1"></v-divider>
          <ServiceAgreementReocurrenceBar :agreement="Agreement">
          </ServiceAgreementReocurrenceBar>
        </v-card>
        <v-card v-else class="pa-2 text-center">
          <h4>{{ $t('servicesystem.common_objects.service_agreement.registered') }}</h4>
          <h5 style="color: rgb(92, 92, 92)">{{
            $t('servicesystem.common_objects.service_agreement.without_job_generation')
          }}</h5>
        </v-card>
      </template>
    </HoverMenu>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import HoverMenu from "@/components/Menus/HoverMenu.vue";
import EditServiceAgreementDialog from "@/components/Dialogs/EditServiceAgreementDialog.vue";

export default {
  name: "MachineServiceAgreementIcon",
  props: {
    machine: Object,
    size: Number,
  },
  components: {
    HoverMenu,
    ServiceAgreementReocurrenceBar: () => import('@/components/ServiceAgreementReocurrenceBar.vue'),
    EditServiceAgreementDialog
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
    };
  },

  mounted() {

  },

  methods: {
    update(val) {
      this.$emit('Update', val);
    }
  },

  computed: {
    indicatorColor() {
      var color = '';
      if (this.machineIsDeactivated) {
        color = '#434343';
      }
      else if (!this.hasAgreement) {
        color = 'disabled';
      }
      else if (this.isExpired) {
        color = 'warning';
      }
      else {
        color = 'success';
      }
      return color;
    },

    foregroundColor() {
      return this.hasNextDateProximity ? 'white' : this.indicatorColor;
    },

    backgroundColor() {
      return this.hasNextDateProximity ? this.nextDateProximity < 0 ? 'accent' : this.indicatorColor : 'transparent';
    },

    customerIsDeactivated() {
      return this.machine && this.machine.Customer && !this.machine.Customer.IsActive;
    },

    machineIsDeactivated() {
      return (this.machine && !this.machine.IsActive) || this.customerIsDeactivated;
    },

    hasAgreement() {
      if (this.machine && this.machine.ServiceAgreement) {
        return true;
      }
      else {
        return false;
      }
    },

    hasNextDateProximity() {
      if (!this.machineIsDeactivated && this.hasAgreement) {
        if (this.Agreement && new Date(this.Agreement.ReocurrencyEndDate) < new Date()) {
          return this.$t("servicesystem.common_objects.commonterms.expired")
        }
        else if (this.machine.ServiceAgreementNextDate == null) {
          return "N/A";
        }
        else if (this.nextDateProximity < this.$store.state.GlobalSettings.PreventiveMaintenanceMachineAffinityDays ?? 45) {
          return this.nextDateProximity;
        }
        else if (this.nextDateProximity == 1) {
          return this.$t("servicesystem.common_objects.commonterms.today");
        }
      }
      return false;
    },

    nextDateProximity() {
      if (this.hasAgreement) {
        var diff = new Date(this.machine.ServiceAgreementNextDate) - new Date();
        var diffInDays = diff / (1000 * 60 * 60 * 24);
        var roundedDiff = Math.ceil(diffInDays);
        return roundedDiff;
      }
      return 0;
    },

    Agreement() {
      return this.machine?.MachineServiceAgreement ?? this.machine.MachineModel?.MachineType?.ServiceAgreement;
    },

    isExpired() {
      return this.Agreement && (new Date(this.Agreement.ReocurrencyEndDate) < new Date())
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>